import { FC, useMemo } from 'react'
import { RawSocialInnerInsight } from 'interfaces/socialInsights'
import { BadgeWithAnnotation } from 'components/features/pfm/BadgeWithAnnotation/BadgeWithAnnotation'
import { isServiceInsight } from 'helpers/insightHelpers'

type MatchRateBadgeProps = {
  insight: RawSocialInnerInsight
  index: number
  AnnotationsContainer: FC
}

export const MatchRateBadge: FC<MatchRateBadgeProps> = (props) => {
  const { insight, index, AnnotationsContainer } = props
  const { match } = insight

  const annotationText = useMemo(() => {
    return match && match.text
  }, [match])

  const title = useMemo(() => {
    return index === 0 ? 'Top Match' : `#${ index + 1 } Match`
  }, [index])

  if (!match || !match.value || isServiceInsight(insight)) {
    return null
  }

  return (
    <BadgeWithAnnotation
      type='match'
      annotationText={ annotationText }
      AnnotationsContainer={ AnnotationsContainer }
    >
      { title }
    </BadgeWithAnnotation>
  )
}
